import React, { Component } from 'react';
import { Switch, Route, Redirect } from "react-router-dom";


import Index from './Componentes/Index/Index';
import Institucion from './Componentes/Institucion/Institucion';

import DiseñoGrafico from './Componentes/DiseñoGrafico/DiseñoGrafico';
import DiseñoInterior from './Componentes/DiseñoInterior/DiseñoInterior';
import DiseñoModa from './Componentes/DiseñoModa/DiseñoModa';
import PublicidadMercadeo from './Componentes/PublicidadMercadeo/PublicidadMercadeo';

import Ingreso from './Componentes/Ingreso/Ingreso';
import Reinscripcion from './Componentes/Ingreso/Reinscripcion';
import Extension from './Componentes/Extension/Extension';
import Eventos from './Componentes/Eventos/Eventos';
import Contacto from './Componentes/Contacto/Contacto';



import Login from './Views/Login';
import Register from './Views/Register';
import VerifyUser from './Views/VerifyUser';
import VerifyRecibo from './Views/VerifyRecibo';
import Validar from './Views/Validar';
import RestartPass from './Views/RestartPass';
import indexRoutes from '../routes/redirect';

import HeaderHome from './HeaderHome';

/* document.cookie =`PHPSESSID=606734356469ab853ab9710404c1278a; path=/`; */

class Home extends Component {
    render() {
        const header = () => {
            switch (this.props.history.location.pathname) {
                case "/login": return(<HeaderHome />)
                case "/Home": return(<HeaderHome />)
                case "/home": return(<HeaderHome />)
                case "/institucion": return(<HeaderHome />)

                case "/diseño_grafico": return(<HeaderHome />)
                case "/diseño_interior": return(<HeaderHome />)
                case "/diseño_moda": return(<HeaderHome />)
                case "/publicidad_mercadeo": return(<HeaderHome />)

                case "/ingreso": return(<HeaderHome />)
                case "/reinscripcion": return(<HeaderHome />)
                case "/extension": return(<HeaderHome />)
                case "/eventos": return(<HeaderHome />)
                case "/contacto": return(<HeaderHome />)
                case "/registro": return(<HeaderHome />)
                case "/reset_password": return(<HeaderHome />)
                default: return null
            }
        }

        return (
            <React.Fragment>
                {header()}
                <Switch>
                    <Route path = "/login" component = {() => <Login/>} />

                    <Route path = "/home" component = {() => <Index />} />
                    <Route path = "/institucion" component = {() => <Institucion/>} />
                    
                    <Route path = "/diseño_grafico" component = {() => <DiseñoGrafico/>} />
                    <Route path = "/diseño_interior" component = {() => <DiseñoInterior/>} />
                    <Route path = "/diseño_moda" component = {() => <DiseñoModa/>} />
                    <Route path = "/publicidad_mercadeo" component = {() => <PublicidadMercadeo/>} />

                    <Route path = "/ingreso" component = {() => <Ingreso/>} />
                    <Route path = "/reinscripcion" component = {() => <Reinscripcion/>} />
                    <Route path = "/extension" component = {() => <Extension/>} />
                    <Route path = "/eventos" component = {() => <Eventos/>} />
                    <Route path = "/contacto" component = {() => <Contacto/>} />

                    <Route path = "/registro" component = {() => <Register/>} />
                    <Route path = "/verify" component = {() => <VerifyUser />} />
                    <Route path = "/recibo" component = {() => <VerifyRecibo />} />
                    <Route path = "/reset_password" component = {() => <RestartPass />} />
                    <Route path = "/validar" component = {() => <Validar />} />
                    <Route path = {indexRoutes[0].path} component = {indexRoutes[0].component} />
                    <Redirect to = "/home" />
                    <Redirect path = "/" to = "/home" />
                </Switch>
            </React.Fragment>
        );
    }
}
 
export default Home;



// WEBPACK FOOTER //
// ./src/site/Home.jsx